/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem, RelatedContentModal, MinisiteField } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';

const RelatedMinisitesModal = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add related minisite"
    subtitle="Find a minisite related to this article"
    okText="ADD MINISITE"
    onSubmit={({ minisite }) => onSubmit(minisite)}
  >
    <MinisiteField
      label="Choose a minisite:"
      name="minisite"
      extra={null}
      wrapperCol={{ span: 24 }}
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Minisite is required' }]}
    />
  </RelatedContentModal>
);

const Item = (minisite) => <InfoItem>{minisite.name}</InfoItem>;

RelatedMinisitesModal.Item = Item;

export default RelatedMinisitesModal;
